import * as React from 'react'

import classNames from 'classnames/bind'
import { min } from 'lodash'

import { useMemo } from 'modules/core/hooks/useMemo'

import styles from './index.module.scss'

const cx = classNames.bind(styles)
const MAX_HEIGHT = 50 // pixels

const colorColumn = (minutes: number, estimationMinutesBaseline: number): string => {
  if (minutes === 0) return 'grey'

  if (minutes < estimationMinutesBaseline) return 'accent'

  return 'brand'
}

const outerHeight = (minutes: number, baselineMinutes: number) => {
  if (baselineMinutes === 0) return 0

  const proportion = minutes / baselineMinutes

  return Math.round(MAX_HEIGHT * proportion)
}

const innerHeight = (
  minutes: number,
  estimationMinutesBaseline: number,
  baselineMinutes: number
) => {
  if (baselineMinutes === 0) return 0

  const proportion = Number(min([minutes, estimationMinutesBaseline])) / baselineMinutes

  return Math.round(MAX_HEIGHT * proportion)
}

interface MinutesPerDayProps {
  baselineMinutes: number
  estimationMinutesBaseline: number
  minutes: number
  wide?: boolean
  windowSize?: number
}

export default function MinutesPerDay({
  baselineMinutes,
  estimationMinutesBaseline,
  minutes,
  wide,
  windowSize,
}: MinutesPerDayProps) {
  const type = colorColumn(minutes, estimationMinutesBaseline)
  const outer = outerHeight(minutes, baselineMinutes)
  const inner = innerHeight(minutes, estimationMinutesBaseline, baselineMinutes)
  const width = useMemo(() => {
    if (windowSize && windowSize > 1920) {
      return '12px'
    } else if (windowSize && windowSize > 1470 && windowSize <= 1920) {
      return '8px'
    } else {
      return '5px'
    }
  }, [windowSize])

  return (
    <div
      className={cx('column', {
        wide,
      })}
      style={{
        height: `${outer}px`,
        width: `${width}`,
        transition: 'width 0.5s',
      }}
    >
      <div
        className={cx('inner', type)}
        style={{
          height: `${inner}px`,
          width: `${width}`,
          transition: 'width 0.5s',
        }}
      />
    </div>
  )
}
